import { Skeleton } from "@/components/ui/skeleton";

import { imageStripSkeletonBox } from "./imageStripLayout";

export function ImageStripLoadingSkeleton({
    isCover,
    width,
    height,
}: {
    isCover: boolean;
    width?: number | null;
    height?: number | null;
}) {
    const box = imageStripSkeletonBox(isCover, width, height);

    return (
        <Skeleton
            aria-hidden
            className="shrink-0"
            style={{ width: box.width, height: box.height }}
        />
    );
}
